import { useQuery } from "@apollo/client";
import { useMemo } from "react";

import { GET_SPACELIFT_VCS_REPO_REVISION } from "./gql";

type UseGetSpaceliftVcsRepoRevisionProps = {
  repoId: string;
  sha: string;
};

const useGetSpaceliftVcsRepoRevision = ({ repoId, sha }: UseGetSpaceliftVcsRepoRevisionProps) => {
  const { data, loading, error, previousData } = useQuery(GET_SPACELIFT_VCS_REPO_REVISION, {
    variables: { repoID: repoId, sha },
  });

  const revision = useMemo(() => {
    return data?.revision || previousData?.revision;
  }, [data, previousData]);

  return {
    revision,
    loading,
    error,
  };
};

export default useGetSpaceliftVcsRepoRevision;
